'use strict'

import React, { useEffect, useState } from 'react'
import ms from 'ms'

import Text, { TextProps } from '@components/kit/text'
import { formatRelativeTimeCondensed } from '@utils/date'

export type MemberListRelativeTimeProps = TextProps & {
  date: string
}

function MemberListRelativeTime({
  date,
  ...rest
}: MemberListRelativeTimeProps) {
  const [formattedDate, setFormattedDate] = useState(
    () => formatRelativeTimeCondensed(date) ?? ''
  )

  useEffect(() => {
    setFormattedDate(formatRelativeTimeCondensed(date) ?? '')
  }, [date])

  useEffect(() => {
    const interval = setInterval(
      () => setFormattedDate(formatRelativeTimeCondensed(date) ?? ''),
      ms('1m')
    )
    return () => clearInterval(interval)
  }, [date])

  return (
    <Text variant='meta' textColor='shade04' {...rest}>
      {formattedDate}
    </Text>
  )
}

export default MemberListRelativeTime
